<template>
  <div class="home-item">
    <img v-if="isImgFrist" :src="src" alt="">
    <ul :style="{padding: padding}">
      <li class="home-item_title">{{title}}</li>
      <li v-for="item in msgs" :key="item" class="home-item_msg">{{`- ${item}`}}</li>
      <li class="home-item_btn" @click="jumpPage">了解详情</li>
    </ul>
    <img v-if="!isImgFrist" :src="src" alt="">
  </div>
</template>

<script>
export default {
  name: 'home-item',
  components: {},
  props: {
    isImgFrist: Boolean,
    src: String,
    title: String,
    msgs: Array,
    padding: String,
    url: String,
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {

  },
  methods: {
    jumpPage() {
      window.location.href = this.url
    },
  },
}
</script>

<style lang="less">
.home-item {
  & > img {
    vertical-align: top;
  }
  & > ul {
    display: inline-block;
  }
  &_title {
    font-size: 26px;
    color: #203152;
    font-weight: bold;
    padding-bottom: 38px;
  }
  &_msg {
    font-size: 20px;
    color: #868E9C;
    padding-bottom: 24px;
  }
  &_btn {
    width: 100px;
    height: 34px;
    border: 1px solid #3F69F7;
    border-radius: 17px;
    font-size: 12px;
    color: #3063F9;
    text-align: center;
    line-height: 34px;
    cursor: pointer;
    margin-top: 34px;
  }
}
</style>
